export default "__VITE_ASSET__FlaWNV2t__"